<mat-sidenav-container autosize>
  <mat-sidenav #sidenav mode="side" [opened]="isSidebarOpen$()"
  [ngStyle]="{ width: isSidebarOpen$() ? '260px' : '0px' }" [mode]="isMobile$() ? 'over' : 'side'">
    <app-sidebar></app-sidebar>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-navbar (toggleSidebarEvent)="toggleSidebar()"></app-navbar>

    <div class="main-content px-4 pt-4" style="height: 88%;">
      <xng-breadcrumb separator=">">
        <ng-container *xngBreadcrumbItem="let breadcrumb">
          <ng-container>{{ breadcrumb | translate }}</ng-container>
        </ng-container>
      </xng-breadcrumb>

      <router-outlet></router-outlet>
    </div>

  </mat-sidenav-content>
  <app-footer></app-footer>
</mat-sidenav-container>
